import React from "react";
import { Flex, Avatar } from "rebass";
export default () => (
  <div
    style={{
      display: "flex",
      height: "100%",
      flexDirection: "column",
      justifyContent: "center"
    }}
  >
    <Flex justify={["center"]} align={["center"]}>
      <Avatar
        size={200}
        src={
          "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-mobile-1O3.jpeg"
        }
      />
    </Flex>
  </div>
);



// WEBPACK FOOTER //
// ./src/Dashboard.js